import { Skeleton as NSkeleton, type SkeletonProps as Props } from '@heroui/react';

export const Skeleton = (props: Props) => {
  return <NSkeleton className='' {...props} />;
};
